export default {
  title: 'Import {type}',
};
